export default "__VITE_ASSET__B2nGfL9y__"